module.exports = __webpack_public_path__ + "static/media/logo-sancor-seguros-white.9d082309.svg";